import { LatLngExpression } from "leaflet";

/**
 * Return the max and the min in the list of points (in traces) comparing the timestamps.
 * @param traces : The traces to extract points and timestamps.
 * @returns The min and the max of this list of timestamp.
 */
export const getMinMaxDateFromTraces = (traces: Trace[]) => {
  const points = traces.map((trace) => trace?.points).flat();
  let minDate = points[0].timestamp;
  let maxDate = points[0].timestamp;

  points.forEach((point) => {
    if (point.timestamp < minDate) {
      minDate = point.timestamp;
    }
    if (point.timestamp > maxDate) {
      maxDate = point.timestamp;
    }
  });

  return { minDate: minDate, maxDate: maxDate };
};

export const pointsToLatLngExpression = (points: Point[]): LatLngExpression[] => {
  return points.map((p) => [p.x, p.y]);
};
